class TeaserBody {
  /**
   * @param {HTMLElement} element - teaser body element
   */
  constructor(element) {
    this.element = element;

    this.selectors = {
      copy: ".js-TeaserBody-copy",
      select: ".js-TeaserBody-intervalSelect select",
      radios: ".js-TeaserBody-intervalRadios input[type='radio']",
    };

    this.elements = {
      copy: this.element.querySelector(this.selectors.copy),
      select: this.element.querySelector(this.selectors.select),
      radios: this.element.querySelectorAll(this.selectors.radios),
    };

    this.copy = {
      oneTime: this.elements.copy.dataset.copyForOneTime,
      others: this.elements.copy.dataset.copyForOtherIntervals,
    };

    this.checkInitialSelectValue();
    this.checkInitialRadiosValue();
    this.addEventListeners();
  }

  /**
   *
   */
  addEventListeners() {
    this.elements.select?.addEventListener("change", (event) => {
      const interval = event.target.value;
      this.changeCopyText(interval);
    });

    this.elements.radios?.forEach((radio) => {
      radio.addEventListener("change", (event) => {
        const interval = event.target.value;
        this.changeCopyText(interval);
      });
    });
  }

  /**
   *
   */
  checkInitialSelectValue() {
    if (!this.elements.select) return;

    const interval = this.elements.select.value;
    this.changeCopyText(interval);
  }

  /**
   *
   */
  checkInitialRadiosValue() {
    if (!this.elements.radios) return;

    const checkedRadio = [...this.elements.radios].find(
      (radio) => radio.checked
    );

    if (!checkedRadio) return;

    const interval = checkedRadio.value;
    this.changeCopyText(interval);
  }

  /**
   * @type {string} interval
   */
  changeCopyText(interval) {
    this.elements.copy.innerHTML =
      interval === "0" ? this.copy.oneTime : this.copy.others;
  }
}

export default TeaserBody;
